import { NavigationRoutes } from 'common/constants';
import { IColumn } from 'components/elements/table-component/table-component';

class FlexibleColumnStorage {
  static set(key: NavigationRoutes, data: IColumn<any>[]) {
    localStorage.setItem(
      `${key}-columns`,
      JSON.stringify(
        data.map((item: any) => {
          return {
            accessorKey: item.accessorKey,
            header: item.header,
            isHidden: item.isHidden,
          };
        }),
      ),
    );
  }

  static get(key: NavigationRoutes) {
    const data = localStorage.getItem(`${key}-columns`);
    return (data ? JSON.parse(data) : []) as IColumn<any>[];
  }

  static remove(key: NavigationRoutes) {
    localStorage.removeItem(`${key}-columns`);
  }
}

export default FlexibleColumnStorage;
